import { render, staticRenderFns } from "./wxorderdetail.vue?vue&type=template&id=6b405082&scoped=true&"
import script from "./wxorderdetail.vue?vue&type=script&lang=js&"
export * from "./wxorderdetail.vue?vue&type=script&lang=js&"
import style0 from "./wxorderdetail.vue?vue&type=style&index=0&id=6b405082&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b405082",
  null
  
)

export default component.exports